module.exports = __webpack_public_path__ + "static/img/bg-safebilling.0e3e16fa.jpg";